import { NotFoundState } from '@/shared/ui';

export function NotFoundPage() {
  return (
    <>
      <header className="page-header">
        <div>
          <h1 className="page-title">Page not found</h1>
        </div>
      </header>
      <div className="content">
        <NotFoundState />
      </div>
    </>
  );
}
